import React from 'react';
import { useUnit } from 'effector-react';
import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';
import { Link } from 'atomic-router-react';
import { $headerOpened, headerOpenedApi } from 'src/models/app';
import { $locale, $isProjectsPage, localeRoutes } from 'src/models/locale';
import { useT } from 'src/i18n';
import { Logo } from 'src/ui/svg/SVGs';

import './Header.scss';

const openHeader = () => {
  headerOpenedApi.setOpen();
};

const closeHeader = () => {
  headerOpenedApi.setUnOpen();
};

export const goToForm = () => {
  const form = document.getElementsByClassName('heading_form')[0];
  form.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const goToTeam = () => {
  const team = document.getElementsByClassName('heading_team')[0];
  team.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const goToSteps = () => {
  const step = document.getElementsByClassName('steps-block')[0];
  step.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const Header = ({ minimal }) => {
  const [headerOpened, locale, isProjectsPage] = useUnit([
    $headerOpened, $locale, $isProjectsPage,
  ]);
  const t = useT();

  const currentRoutes = localeRoutes[locale];
  const otherLocale = locale === 'ru' ? 'en' : 'ru';
  const switchRoute = isProjectsPage
    ? localeRoutes[otherLocale].projects
    : localeRoutes[otherLocale].home;

  if (minimal) {
    return (
      <Fade top>
        <div className="header">
          <div className="header__logo">
            <Link to={currentRoutes.home}>
              <Logo />
            </Link>
          </div>

          <div className="nav">
            <Link to={currentRoutes.home} className="nav__link link">
              {t.header.toHome}
            </Link>
            <Link to={switchRoute} className="nav__link link lang-switch">
              {t.header.langSwitch}
            </Link>
          </div>

          <div className="open-button open-button_minimal">
            <Link to={switchRoute} className="nav__link link lang-switch">
              {t.header.langSwitch}
            </Link>
          </div>
        </div>
      </Fade>
    );
  }

  return (
    <>
      <Fade top>
        <div className="header">
          <div className="header__logo">
            <Logo />
          </div>

          <div className="nav">
            <div
              className="nav__link link"
              onClick={goToTeam}
              onTouchStart={goToTeam}
            >
              {t.header.about}

            </div>
            <div
              className="nav__link link link_centered"
              onClick={goToSteps}
              onTouchStart={goToSteps}
              style={{marginRight: 0}}
            >
              {t.header.steps}

            </div>
            <Link to={currentRoutes.projects} className="nav__link link link_centered">
              {t.header.projects}
            </Link>
            <div
              className="nav__link link"
              onClick={goToForm}
              onTouchStart={goToForm}
            >
              {t.header.contact}

            </div>
            <Link to={switchRoute} className="nav__link link lang-switch">
              {t.header.langSwitch}
            </Link>
          </div>

          <div
            onClick={headerOpened ? closeHeader : openHeader}
            className={`open-button ${headerOpened ? 'open-button_opened' : ''}`}
          >
            <span className={`line ${headerOpened ? 'line_top_open' : ''}`} />
            <span className={`line ${headerOpened ? 'line_bottom_open' : ''}`} />
          </div>
        </div>
      </Fade>

      <div className={`header-nav-block ${headerOpened ? 'header-nav-block_opened' : ''}`}>
        <Zoom when={headerOpened} cascade collapse duration={550}>
          <ul className="nav">
            <li
              className="nav__link link"
              onClick={() => { goToTeam(); closeHeader(); }}
            >
              {t.header.about}
            </li>
            <li
              className="nav__link link"
              onClick={() => { goToSteps(); closeHeader(); }}
            >
              {t.header.steps}
            </li>
            <li className="nav__link link" onClick={closeHeader}>
              <Link to={currentRoutes.projects} className="nav__link-anchor">{t.header.projects}</Link>
            </li>
            <li
              className="nav__link link"
              onClick={() => { goToForm(); closeHeader(); }}
            >
              {t.header.contact}
            </li>
            <li className="nav__link link" onClick={closeHeader}>
              <Link to={switchRoute} className="nav__link-anchor">{t.header.langSwitch}</Link>
            </li>
          </ul>
        </Zoom>
      </div>
    </>
  );
};
